import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useAuth } from '../AuthContext';
import API from '../api';

const Login_Redirect_Handler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const { login } = useAuth();
  const selectedPlan = location.state?.selectedPlan;

useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const status = params.get('status');
    const planName = params.get('planName');
    const planId = params.get('packageId');
    const price = params.get('price');
    const id = params.get('id');
    const referralCode = params.get('referralCode');

    if (status === 'activated') {
      setMessage('✅ Your account has been activated. Logging you in...');
    } else if (status === 'already_activated') {
      setMessage('ℹ️ Your account is already activated. Logging you in...');
    } else if (status === 'invalid_or_expired') {
      setMessage('❌ Activation link is invalid or expired.');
    }

    if (token) {
      localStorage.setItem('authToken', token);

      try {
        const decoded = jwtDecode(token);
        const user = {id: decoded.id, email: decoded.email, name: decoded.name, referralCode: referralCode };
       
        // Optionally, you could fetch user ID from backend if needed
        // For now, simulate with email and go to dashboard
        login(user); // ✅ Save in context
        localStorage.setItem("user", JSON.stringify(user));

        setTimeout(() => {
          if(planName === 'Free Trial' || planName === '' || planName === null)
            navigate('/dashboard');
          else
          { 
               const plan = {
                name: planName,
                id: planId,
                price: price
            };
            console.log(planId);

            navigate('/payment', { state: { selectedPlan: plan } });
          }
        }, 2000);
      } catch (err) {
        console.error('Invalid token:', err);
        setMessage('Failed to decode token.');
      }
    }
  }, [location, navigate, login]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Account Activation</h2>
      <p>{message}</p>
    </div>
  );
};

export default Login_Redirect_Handler;
